import React from 'react';
import Modal from 'ui-library/components/Modal/Modal';
import Tabs from 'ui-library/components/Tabs/Tabs';
import TabPane from 'ui-library/components/Tabs/TabPane/TabPane';
import Loader from 'ui-library/components/Loader/Loader';
import Infobox from 'ui-library/components/Infobox/Infobox';

import { LangSource } from 'translations/adaptors/languagesAdapt';
import SystemMessageForm from './SystemMessageForm';
import { Language, IFormType } from './SystemMessage.types';

const SystemMessageFormModal = ({
    visible,
    languages,
    currentTab,
    setCurrentTab,
    onCloseModal,
    messageData,
    onSuccess,
    formType,
    isLoading,
    formError,
    t,
}: {
    visible: boolean;
    languages: LangSource[];
    currentTab: Language;
    setCurrentTab: (lang: Language) => void;
    onCloseModal: () => void;
    messageData: any;
    onSuccess: () => void;
    formType?: IFormType;
    isLoading?: boolean;
    formError?: string | null;
    t: (key: string) => string;
}) => (
    <Modal
        title={t('SystemMessage.Modal.Title')}
        visible={visible}
        width={800}
        height="90%"
        footer={<span />}
        borderRadius
        className="system-message-modal"
    >
        <Tabs
            activeKey={currentTab}
            onChange={(key) => setCurrentTab(key as Language)}
            className="system-message-language-tab"
        >
            {languages.map((language) => (
                <TabPane
                    tab={(
                        <div className="tab-title">
                            <span>{language.label}</span>
                        </div>
                    )}
                    key={language.value}
                />
            ))}
        </Tabs>
        {isLoading ? (
            <Loader />
        ) : (
            <SystemMessageForm
                activeLang={currentTab}
                languages={languages}
                setCurrentLang={(lang) => setCurrentTab(lang as Language)}
                onCloseModal={onCloseModal}
                messageData={messageData}
                onCreateMessageSuccess={onSuccess}
                formType={formType}
            />
        )}
        {formError && (
            <Infobox error>
                <span>{formError}</span>
            </Infobox>
        )}
    </Modal>
);

export default SystemMessageFormModal;
